var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
// Material ui Imports
// Custom components imports (and hooks and helpers)
import { EDragContentOptions } from "../models/current.models";
import { Grid } from "@mui/material";
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// Shows part of a preview image
export default function VTImmersiveImageSegment(_a) {
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##
    var size = _a.size, segmentSrc = _a.segmentSrc, localHandleDrag = _a.localHandleDrag, immersiveImagesTitle = _a.immersiveImagesTitle, sx = _a.sx;
    //-------------------------------------------------------------------------------------------------
    // ## USE SELECTOR ##
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##
    //-------------------------------------------------------------------------------------------------
    // ## USE EFFECTS ##
    //-------------------------------------------------------------------------------------------------
    // ## CUSTOM FUNCTIONS ##
    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    return (_jsxs(Grid, __assign({ sx: sx, container: true }, { children: [size === "Large" && (_jsx("img", { src: segmentSrc + "/l.jpg", draggable: true, onDragStart: function () {
                    return localHandleDrag(true, EDragContentOptions.IMAGE_360, segmentSrc);
                }, onDragEnd: function () { return localHandleDrag(false); }, style: { borderRadius: "15px 0px 0px 15px", width: "33%" }, title: immersiveImagesTitle })), _jsx("img", { 
                // Adds a face to the src for a preview
                src: segmentSrc + "/f.jpg", draggable: true, onDragStart: function () {
                    return localHandleDrag(true, EDragContentOptions.IMAGE_360, segmentSrc);
                }, onDragEnd: function () { return localHandleDrag(false); }, style: {
                    borderRadius: size === "Large"
                        ? "0px"
                        : size === "Medium"
                            ? "15px 0px 0px 15px"
                            : "15px",
                    width: size === "Large" ? "33%" : size === "Medium" ? "50%" : "100%",
                } }), (size === "Medium" || size === "Large") && (_jsx("img", { src: segmentSrc + "/r.jpg", draggable: true, onDragStart: function () {
                    return localHandleDrag(true, EDragContentOptions.IMAGE_360, segmentSrc);
                }, onDragEnd: function () { return localHandleDrag(false); }, style: {
                    borderRadius: "0px 15px 15px 0px",
                    width: size === "Large" ? "33%" : "50%",
                } }))] })));
}
